import React from 'react';
import { CHANGE, pt, topFromBaseline, u } from './geometry';

/** Колонтитул Comabooks: Playfair 36pt, baseline y 1450; чётная — номер слева,
 *  автор справа; нечётная — название слева, номер справа. Отступ 160 px макета. */
export const ComabooksFooter: React.FC<{ title?: string; author?: string; pageNumber?: number }> = ({
  title = '',
  author = '',
  pageNumber,
}) => {
  if (pageNumber === undefined) return null;
  const even = pageNumber % 2 === 0;
  const label = even ? author : title;
  const margin = u(160 + CHANGE);
  const base: React.CSSProperties = { top: topFromBaseline(1450 + CHANGE, 36), fontSize: pt(36) };
  return (
    <>
      {label && (
        <span className="cbp__footer" style={even ? { ...base, right: margin } : { ...base, left: margin }}>
          {label}
        </span>
      )}
      <span className="cbp__footer" style={even ? { ...base, left: margin } : { ...base, right: margin }}>
        {pageNumber}
      </span>
    </>
  );
};
